import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import store from '@src/state/store.js'
import { isCapacitor } from '@src/utils/platformUtil.js'

let hideTimeoutId = null

export function isTawkToAllowed() {
  if (!window.Tawk_API) return false
  const activeRole = store?.state?.layout?.activeRole
  return [TENANT_ROLES.CAMPUS_ADMIN, TENANT_ROLES.SUPER_ADMIN].includes(activeRole)
}

export function showTawkWidget() {
  if (!window.Tawk_API) return
  window.Tawk_API.showWidget()

  if (isCapacitor()) {
    clearTimeout(hideTimeoutId)
    hideTimeoutId = setTimeout(() => {
      window.Tawk_API?.hideWidget()
    }, 10000)
  }
}

export function hideTawkWidget() {
  clearTimeout(hideTimeoutId)
  if (window.Tawk_API) {
    window.Tawk_API.hideWidget()
  }
}
